import { __assign, __spreadArray } from "tslib";
// DS: C130
import React, { useContext, useMemo } from 'react';
import c from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import { getDeviationResourceType } from '../../DeviationViews/_helpers';
import Flex from '@wix/da-ds/pkg/Flex';
import Badge from '../../Badge';
import CustomNotificationProvider from '../../Notifications/CustomNotificationContext';
import { getDeviationNotificationQueue } from '../../DeviationPage/redux/helpers';
import PopoverNotification from '../../Notifications/PopoverNotification';
import { NotificationType } from '../../Notifications';
import { ScreenSizeContext } from '../../Measured';
import CoreBadgeButton from '../CoreBadgeButton';
import { sortPapiBadge, badgeNotificationsFilter } from '../utils';
import s from './CoreBadgeList.scss';
var CoreBadgeList = function (_a) {
    var _b;
    var deviation = _a.deviation, className = _a.className;
    var isMobile = useContext(MobileContext);
    var badgesSorted = useMemo(function () {
        var _a, _b;
        var badges = (_b = (_a = deviation.extended) === null || _a === void 0 ? void 0 : _a.awardedBadges) !== null && _b !== void 0 ? _b : [];
        var sorted = __spreadArray([], badges, true);
        sorted.sort(sortPapiBadge);
        return sorted;
    }, [(_b = deviation.extended) === null || _b === void 0 ? void 0 : _b.awardedBadges]);
    var screenWidth = useContext(ScreenSizeContext).width;
    if (badgesSorted.length === 0) {
        return null;
    }
    return (React.createElement(CustomNotificationProvider, { queueName: getDeviationNotificationQueue(deviation) },
        React.createElement(Section, { className: c(s['root'], className) },
            React.createElement(VisuallyHidden, null,
                React.createElement(Heading, null, "Badge Awards")),
            badgesSorted.map(function (badge, idx) {
                return badge.stackCount && (React.createElement(PopoverNotification, { key: "CoreBadgeList-" + idx, placement: isMobile || screenWidth <= 1250 ? 'top' : undefined, secondaryPlacement: isMobile || screenWidth <= 1250 ? 'end' : undefined, contentClassName: s['notification'], notificationTypes: [NotificationType.Badge], notificationFilter: badgeNotificationsFilter(badge.name) },
                    React.createElement(CoreBadgeButton, { className: c(s['button'], idx === 0 && s['button-first']), key: badge.name, type: badge.name, badges: badgesSorted, recipient: {
                            typeId: getDeviationResourceType(deviation),
                            itemId: deviation.deviationId,
                            user: deviation.author,
                        }, biData: {
                            evid: BiEventType.BADGE_STATISTICS_CLICK,
                            sectionname: 'deviation',
                            typeid: getDeviationResourceType(deviation),
                            itemid: deviation.deviationId,
                        } },
                        React.createElement(Flex, { className: s['badge-box'], alignItems: "center" },
                            React.createElement(Badge, __assign({}, badge, { className: s['badge'] })),
                            ' ',
                            badge.stackCount))));
            }))));
};
CoreBadgeList.displayName = 'CoreBadgeList';
export default CoreBadgeList;
//# sourceMappingURL=CoreBadgeList.js.map